<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';

  const dispatch = createEventDispatcher();

  export let pendingUserData = {};
  export let mobile = false;
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  .invite-congrats {
    .invite-background {
      position: absolute;
      left: 0px;
      right: 0px;
      top: 0px;
      border: 0px;
      z-index: -1;
      height: 100%;
    }

    .confetti {
      height: 64px;
      width: 64px;
      margin: 0 auto;

      margin-top: 100px;
    }

    .ui-header {
      font-weight: bold;
      font-size: 32px;
      line-height: 40px;
      text-align: center;
      margin-top: 25px;
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
      max-width: 316px;
    }

    .button-wrapper {
      position: absolute;
      bottom: 64px;
    }
  }

  .mobile {
    padding: 30px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 200px);

    .invite-background {
      height: 100%;
      width: 100%;
    }

    .ui-header {
      font-size: 25px;
      line-height: 32px;
      width: 250px;
      max-width: 250px;
    }
  }

  .loss-aversion {
    background-color: #fff;
    width: 488px;
    border-radius: 16px;
    margin: 0 auto;
    margin-top: 40px;

    .inner {
      font-size: 16px;
      font-weight: 400;
      line-height: 40px;
      padding: 24px 32px;

      .fire {
        height: 16px;
        margin-bottom: 4px;
      }

      .strong {
        font-weight: 600;
      }
    }
  }

  .mobile {
    .confetti {
      margin-top: 0px;
    }

    .loss-aversion {
      margin-top: 20px;
      width: auto;
      .inner {
        line-height: 32px;
      }
    }

    .button-wrapper {
      bottom: 4%;
    }
  }
</style>

<div class="invite-congrats" class:mobile={mobile}>
  <div>
    <img
      src="/images/app-invites/{mobile ? 'congrats-background-mobile.png' : 'congrats-background.png'}"
      class="invite-background"
      alt="confetti-background" />

    <div class="confetti"><img alt="party-popper" src="/images/app-invites/partypopper@2x.png" /></div>

    <div class="ui-header">Welcome to Benable {pendingUserData.name}!</div>

    <div class="loss-aversion">
      <div class="inner">
        {#if mobile}
          Create your first list and add a recommendation in the next <br />
          <span class="strong">30 minutes</span>, and you’ll be entered to win
          <span class="strong">a prize</span>
          and be featured on our Instagram! <img class="fire" alt="fire-emoji" src="/images/featured/fire.svg" />
        {:else}
          Create your first list and add a recommendation <br /> in the next
          <span class="strong">30 minutes</span>, and you’ll be entered to win <br />
          <span class="strong">a prize</span>
          and be featured on our Instagram!
          <img class="fire" alt="fire-emoji" src="/images/featured/fire.svg" />
        {/if}
      </div>
    </div>

    <div
      class="button-wrapper"
      style={mobile ? 'width: 180px; left: calc(50% - 90px);' : 'width: 316px; left: calc(50% - 158px);'}>
      <Button
        on:click={() => {
          dispatch('finished');
        }}
        text="Let’s go!" />
    </div>
  </div>
</div>
